// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"SapoyRSzHGANG26DyIGN","triggerElement":"SIvUdfCXx3ABLxrBVcnx","triggerButton":"Up11F0eL9jRhii36ked2"};